export default __webpack_public_path__ + "static/media/gear_pink.003ef369.svg";